import Alert from '@mui/material/Alert';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import React from 'react';
import { ChargePointSummary, ChargingProfile } from '../../../../../app/ApiGen';
import { Normalised } from '../../../../../utils/request';

export class Charger implements Partial<Normalised<ChargePointSummary>> {
  model?: Normalised<ChargePointSummary>['model'];

  vendor?: Normalised<ChargePointSummary>['vendor'];

  constructor({ model, vendor }: Normalised<ChargePointSummary>) {
    this.model = model;
    this.vendor = vendor;
  }

  get isE2Series(): boolean {
    if (!this.model) {
      return false;
    }
    return this.vendorIsEvnex && (this.model.startsWith('E2') || this.model === 'Home');
  }

  get isEXSeries(): boolean {
    if (!this.model) {
      return false;
    }
    return this.vendorIsEvnex && (this.model.startsWith('E7') || this.model.startsWith('X'));
  }

  get vendorIsEvnex(): boolean {
    return this.vendor === 'Evnex';
  }
}

export const ProfileConflictWarning: React.FC<{
  chargePoint: Normalised<ChargePointSummary>;
  loadManagement: ChargingProfile | undefined;
}> = ({ chargePoint, loadManagement }) => {
  const warning = 'Load Management and Amber profiles do not merge correctly.';

  if (!!chargePoint.integrations?.amberElectric && loadManagement?.enabled) {
    const charger = new Charger(chargePoint);
    if (charger.isE2Series) {
      return <Alert severity="warning">{warning} Turn off Load Management and set a ChargingCurrentLimit.</Alert>;
    }
    if (charger.isEXSeries) {
      return <Alert severity="warning">{warning} Turn off Load Management.</Alert>;
    }
  }

  return <SimpleTreeView data-testid="no-warning" />;
};
